import { ATTRIBUTION_STORAGE_KEY, CURRENT_ATTRIBUTION_VERSION, isAttributionContext, } from "@next-platform/packages-ts-types";
import { localAsyncStorage } from "../diProviders";
/**
 * Reads the persisted attribution envelope from the injected storage
 * backend. Returns `undefined` when nothing is stored, the JSON is
 * unparseable, or the envelope fails `isAttributionContext`.
 *
 * Also discards envelopes whose `version` does not match
 * `CURRENT_ATTRIBUTION_VERSION` — forward-compat policy from the plan:
 * unknown versions are dropped rather than migrated silently.
 */
export async function readAttributionContext() {
    const raw = await localAsyncStorage.getItem(ATTRIBUTION_STORAGE_KEY);
    if (!raw) {
        return undefined;
    }
    let parsed;
    try {
        parsed = JSON.parse(raw);
    }
    catch {
        return undefined;
    }
    if (!isAttributionContext(parsed)) {
        return undefined;
    }
    if (parsed.version !== CURRENT_ATTRIBUTION_VERSION) {
        return undefined;
    }
    return parsed;
}
/**
 * Serializes and persists the envelope. Errors from the storage backend
 * propagate so callers can decide (log vs. fail).
 */
export async function writeAttributionContext(context) {
    await localAsyncStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(context));
}
/**
 * Removes the persisted envelope. Used by test cleanup and account-delete
 * flows.
 */
export async function clearAttributionContext() {
    await localAsyncStorage.removeItem(ATTRIBUTION_STORAGE_KEY);
}
